import React from 'react';
import { Button, Popconfirm, Space, Table } from 'antd';
import {
  useDeleteSubTemple,
  useGetSubTemples,
} from '../../services/sub-temple/sub-temple.service.hook';
import TmsSubTempleCreateModal from './tms-sub-temple-create-modal';

const TMSSubTemplesManagement = ({ templeId }) => {
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);

  const { data: subTemples, isLoading } = useGetSubTemples(
    templeId,
    page,
    limit
  );

  const { mutate: deleteSubTemple, isPending: isDeleteLoading } =
    useDeleteSubTemple();

  const [showCreateModal, setShowCreateModal] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  const handleEdit = (record) => {
    setEditData(record);
    setShowCreateModal(true);
  };

  const handleDelete = (record) => {
    deleteSubTemple({ templeId, subTempleId: record.id });
  };

  const columns = [
    {
      title: 'Short Name',
      dataIndex: 'shortName',
      key: 'shortName',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size='middle'>
          <a onClick={() => handleEdit(record)}>Edit</a>
          <Popconfirm
            title='Are you sure？'
            okText='Yes'
            cancelText='No'
            onConfirm={() => handleDelete(record)}
          >
            <a style={{ color: 'red' }}>Delete</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ float: 'left', marginBottom: '5px' }}>
        <Button onClick={() => setShowCreateModal(true)} type='primary'>
          Create Sub Temple
        </Button>
      </div>
      <div>
        <Table
          size='small'
          columns={columns}
          dataSource={subTemples?.items}
          loading={isLoading || isDeleteLoading}
          onChange={handleTableChange}
          pagination={{
            current: page,
            pageSize: limit,
            total: subTemples?.meta?.totalItems,
          }}
        />
      </div>
      <TmsSubTempleCreateModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        templeId={templeId}
        editData={editData}
      />
    </>
  );
};

export default TMSSubTemplesManagement;
